import { useState } from 'react';
import { useAuditQuery, type AuditFilters as Filters } from '../api/audit';
import { BackLink } from '../components/layout/BackLink';
import { AuditFilters } from '../components/audit/AuditFilters';
import { AuditRow } from '../components/audit/AuditRow';

export function AuditPage() {
  const [filters, setFilters] = useState<Filters>({ limit: 100 });
  const q = useAuditQuery(filters);
  return (
    <>
      <BackLink />
      <h1>Audit</h1>
      <AuditFilters initial={filters} onSearch={(f) => { setFilters(f); q.refetch(); }} />
      <h2>Results</h2>
      {q.isLoading && <div className="skeleton" style={{ height: 100 }} />}
      {q.isError && <div className="banner danger">{(q.error as Error).message}</div>}
      {q.data && q.data.length === 0 && <div className="muted">No actions match the current filters.</div>}
      {q.data && q.data.map((r, i) => <AuditRow key={i} row={r as Parameters<typeof AuditRow>[0]['row']} />)}
    </>
  );
}
